import React from 'react';
import { Star } from 'lucide-react';
import { RotatingWord } from './RotatingWord';
export function Hero() {
  return <section className="w-full min-h-[80vh] bg-orla-bone flex items-center justify-center py-16 md:py-24 lg:py-32 px-4 md:px-8 lg:px-12" data-id="element-189">
      <div className="max-w-[1240px] w-full mx-auto flex flex-col lg:flex-row gap-12 lg:gap-16 items-center" data-id="element-190">
        {/* Left Column: Text & CTAs */}
        <div className="w-full lg:w-[55%] flex flex-col items-start" data-id="element-191">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border-2 border-orla-saffron bg-orla-bone mb-8" data-id="element-192">
            <div className="flex gap-0.5" data-id="element-193">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-orla-saffron text-orla-saffron" data-id="element-194" />)}
            </div>
            <span className="text-orla-ink font-body font-semibold text-[13px]" data-id="element-195">
              40,000+ women in their prime
            </span>
          </div>

          {/* Headline */}
          <h1 className="font-display font-black text-[44px] lg:text-[72px] leading-[1.05] tracking-[-0.02em] text-orla-ink max-w-[800px]" data-id="element-196">
            We treat <RotatingWord data-id="element-197" /> so you can stay in your prime.
          </h1>

          {/* Supporting Text */}
          <p className="font-body font-normal text-[17px] text-orla-muted max-w-[480px] mt-6 leading-relaxed" data-id="element-198">
            Perimenopause starts earlier than most doctors admit. Orla's
            board-certified physicians treat the symptoms you feel — and the
            ones you don't yet recognize — with bioidentical HRT made for your
            body.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 mt-8 w-full sm:w-auto" data-id="element-199">
            <div className="flex flex-col gap-2" data-id="element-200">
              <button className="bg-orla-sienna text-orla-bone font-body font-semibold text-[15px] rounded-full px-7 py-3.5 hover:bg-orla-sienna/90 transition-colors w-full sm:w-auto text-center" data-id="element-201">
                Start My Care
              </button>
              <span className="font-body text-[12px] text-orla-muted text-center sm:text-left" data-id="element-202">
                Ready to begin? Start your medical intake.
              </span>
            </div>

            <div className="flex flex-col gap-2" data-id="element-203">
              <button className="bg-transparent border-2 border-orla-sienna text-orla-sienna font-body font-semibold text-[15px] rounded-full px-7 py-3.5 hover:bg-orla-sienna/5 transition-colors w-full sm:w-auto text-center" data-id="element-204">
                Take the Quiz
              </button>
              <span className="font-body text-[12px] text-orla-muted text-center sm:text-left" data-id="element-205">
                Not sure if Orla is right for you? Start here.
              </span>
            </div>
          </div>
        </div>

        {/* Right Column: Image */}
        <div className="w-full lg:w-[45%] h-[500px] lg:h-[600px] relative mt-8 lg:mt-0" data-id="element-206">
          <img src="https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=800&q=80" alt="Woman in natural light looking off camera" className="w-full h-full object-cover rounded-2xl lg:rounded-l-none lg:rounded-r-2xl shadow-xl shadow-orla-ink/5" data-id="element-207" />
        </div>
      </div>
    </section>;
}